import { useEffect } from 'react';
import useSession from 'app/hooks/useSession';
import useRouter from 'app/hooks/useRouter';

export default () => {
  const {
    location: { state: { route } = {} }
  } = useRouter();
  const session = useSession();

  useEffect(() => {
    if (route) {
      session.setRoute(route);
    }
  }, [route, session]);
};
